import { Link } from "react-router-dom";
import { Eye, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function DemoBanner() {
  const { t } = useTranslation();
  return (
    <div
      className="border-b border-[#EF9F27]/30 bg-gradient-to-r from-[#EF9F27]/10 via-[#EF9F27]/5 to-transparent backdrop-blur-md"
      data-testid="demo-banner"
    >
      <div className="px-4 lg:px-6 py-2.5 flex items-center gap-3 flex-wrap">
        <div className="flex items-center gap-2 min-w-0">
          <div className="w-6 h-6 rounded-md bg-[#EF9F27]/20 border border-[#EF9F27]/40 flex items-center justify-center shrink-0">
            <Eye className="w-3 h-3 text-[#EF9F27]" />
          </div>
          <div className="min-w-0">
            <div className="text-[11px] font-semibold tracking-[0.18em] uppercase text-[#EF9F27]">
              {t("demo.banner_label")}
            </div>
            <div className="text-xs text-zinc-300 truncate">
              {t("demo.banner_help")}
            </div>
          </div>
        </div>
        <div className="flex-1" />
        <Link
          to="/login"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-[#378ADD] hover:bg-[#2C72BD] text-white text-xs font-medium transition-colors shrink-0"
          data-testid="demo-banner-cta"
        >
          {t("demo.banner_cta")} <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
}
